import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../api';
import { setError, setMessage } from '../../../redux/slice';

export const doGetCarrierIntegrations = createAsyncThunk(
  'carriers/doGetCarrierIntegrations',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.getCarrierIntegrations(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doGetCarriers = createAsyncThunk<any, any>('carriers/doGetCarriers', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getCarriers(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateCarrierIntegration = createAsyncThunk(
  'carriers/doCreateCarrierIntegration',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doCreateCarrierIntegration(params);
      if (!error) thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doCreateCarrier = createAsyncThunk<any, any>('carriers/doCreateCarrier', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.createCarrier(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateCarrier = createAsyncThunk<any, any>('carriers/doUpdateCarrier', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.updateCarrier(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateCarrierIntegration = createAsyncThunk(
  'carriers/doUpdateCarrierIntegration',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doUpdateCarrierIntegration(params);
      if (!error) thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doGetCarrier = createAsyncThunk<{ id: number }, any>('carriers/doGetCarrier', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetCarrier(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateCarrierHub = createAsyncThunk<any, any>(
  'carriers/doCreateCarrierHub',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.createCarrierHub(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
        await thunkAPI.dispatch(doGetCarrier({ id: params.carrierId }));
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doUpdateCarrierHub = createAsyncThunk<any, any>(
  'carriers/doUpdateCarrierHub',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.updateCarrierHub(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
